import { render, staticRenderFns } from "./AgilePickupDeclaredValueTable.vue?vue&type=template&id=29266e4e&scoped=true"
import script from "./AgilePickupDeclaredValueTable.vue?vue&type=script&lang=ts"
export * from "./AgilePickupDeclaredValueTable.vue?vue&type=script&lang=ts"
import style0 from "./AgilePickupDeclaredValueTable.vue?vue&type=style&index=0&id=29266e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29266e4e",
  null
  
)

export default component.exports